/** Image widths the CDN serves. No zod: imported by browser code through images.ts. */

/** Widths the CDN serves. Others are rounded up, so the variant cache stays small. */
export const IMAGE_WIDTHS = [96, 160, 240, 320, 480, 640, 960, 1280, 1920] as const;

export const MAX_IMAGE_WIDTH = 1920;

/** The allowed width at or above `width`, or the largest. */
export function variantWidth(width: number): number {
	return IMAGE_WIDTHS.find((w) => w >= width) ?? MAX_IMAGE_WIDTH;
}
